/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = PayNow
 *
 * 1 = PayLater
 */
export enum BumperProductType {
  PayNow = 0,
  PayLater = 1,
}
